import { c as _c } from "react/compiler-runtime";
import { ProjectActions } from "@components/common/project-actions";
import { ProjectCardDate } from "@components/common/project-card/project-card-date";
import { ProjectCardTop } from "@components/common/project-card/project-card-top";
import { Card, Tooltip } from "@flat-ui";
import { hasDescribeOnlyPermission } from "@utils/permission-control/project-permission-control";
import { getProjectAccessAndSize } from "@utils/project-utils";
import { cardProperties } from "@utils/ui-utils";
/**
 * Renders a project card: thumbnail, date, name, access level and actions.
 */
export function ProjectCardContent(t0) {
  const $ = _c(27);
  const {
    project,
    sortBy,
    isProjectProcessing,
    href,
    onClick,
    thumbnailLinkTo,
    onThumbnailClick
  } = t0;
  let t1;
  if ($[0] !== project) {
    t1 = hasDescribeOnlyPermission(project);
    $[0] = project;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isDescribeOnly = t1;
  let t2;
  if ($[2] !== onThumbnailClick || $[3] !== project || $[4] !== thumbnailLinkTo) {
    t2 = <ProjectCardTop project={project} thumbnailLinkTo={thumbnailLinkTo} onThumbnailClick={onThumbnailClick} />;
    $[2] = onThumbnailClick;
    $[3] = project;
    $[4] = thumbnailLinkTo;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== project || $[7] !== sortBy) {
    t3 = <ProjectCardDate project={project} sortBy={sortBy} />;
    $[6] = project;
    $[7] = sortBy;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== project.name) {
    t4 = <Tooltip title={<var>{project.name}</var>}><var>{project.name}</var></Tooltip>;
    $[9] = project.name;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isDescribeOnly || $[12] !== project) {
    t5 = isDescribeOnly ? undefined : getProjectAccessAndSize(project);
    $[11] = isDescribeOnly;
    $[12] = project;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== isDescribeOnly || $[15] !== project) {
    t6 = isDescribeOnly ? undefined : <ProjectActions project={project} contextType="project-tiles-view" />;
    $[14] = isDescribeOnly;
    $[15] = project;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      height: cardProperties.height,
      marginTop: cardProperties.marginTop
    };
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== href || $[19] !== isProjectProcessing || $[20] !== onClick || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6) {
    t8 = <Card dataTestId="project-card" loading={isProjectProcessing} href={href} onClick={onClick} actionsVisibility="hover" media={t2} subheader={t3} title={t4} footer={t5} actions={t6} sx={t7} />;
    $[18] = href;
    $[19] = isProjectProcessing;
    $[20] = onClick;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}